import React from 'react';
import {
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    tableCellClasses,
    Typography
} from "@mui/material";
import {styled} from "@mui/material/styles";
import PrimaryButton from "../../Common/PrimaryButton";
// import {lightBlue} from "@mui/material/colors";
// import {getTripFormattedDate} from "../../utils";
import {useHistory, useParams} from "react-router-dom";
import {endOfDay, isPast, parse} from "date-fns";
import PreTripCard from "./PreTripCard";
import {BookingPropTypes} from "../../../utils/PropTypes/BookingPropTypes";

const StyledTableCell = styled(TableCell)(({theme}) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.action.hover,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: '1.4rem',
        padding: '4px 16px 4px 16px',
        verticalAlign: 'middle !important',
    },
}));

const StyledTableRow = styled(TableRow)(({theme}) => ({
    '&:nth-of-type(even)': {
        backgroundColor: theme.palette.action.hover,
    },
    '&:last-child td, &:last-child th': {
        border: 0,
        fontSize: '1.4rem',
        padding: '4px 16px 4px 16px',
    },
    '& td:last-child': {
        textAlign: 'center',
        verticalAlign: 'middle !important'
    },
    '& td:nth-of-type(2)': {
        textAlign: 'end',
    },
}));

const PREFIX = 'PaymentCard';

const classes = {
    root: `${PREFIX}-root`,
    status: `${PREFIX}-status`,
    paid: `${PREFIX}-paid`,
    waiting: `${PREFIX}-waiting`,
    tripInfoContainer: `${PREFIX}-tripInfoContainer`,
    tripTitle: `${PREFIX}-tripTitle`,
    tripDetailsContainer: `${PREFIX}-tripDetailsContainer`,
    tripDetails: `${PREFIX}-tripDetails`,
    footerInfo: `${PREFIX}-footerInfo`,
    preTripHeading: `${PREFIX}-preTripHeading`,
    preTripText: `${PREFIX}-preTripText`,
    PreTripBtn: `${PREFIX}-PreTripBtn`,
}

const PaymentPaper = styled(Paper)(({theme}) => ({
    [`&.${classes.root}`]: {
        marginTop: '20px',
    },
    [`& .${classes.roomName}`]: {
        fontSize: '2.4rem',
        fontWeight: 600,
        textAlign: 'left',
        marginBottom: '10px',
    },
    [`& .${classes.status}`]: {
        color: 'white',
        padding: '5px',
        textTransform: 'uppercase',
        fontWeight: '500',
        fontSize: '1.4rem',
        letterSpacing: '1.6px'
    },
    [`& .${classes.paid}`]: {
        backgroundColor: theme.palette.success.main,
    },
    [`& .${classes.waiting}`]: {
        backgroundColor: theme.palette.warning.main,
    },
    [`& .${classes.tripInfoContainer}`]: {
        marginTop: '20px'
    },
    [`& .${classes.tripTitle}`]: {
        fontSize: '2.4rem',
        letterSpacing: '1.2px',
        fontWeight: 600,
        textTransform: 'capitalize',
    },
    [`& .${classes.tripDetailsContainer}`]: {
        display: 'flex',
        alignItems: 'center',
    },
    [`& .${classes.tripDetails}`]: {
        fontSize: '1.2rem',
        marginLeft: '5px'
    },
    [`& .${classes.footerInfo}`]: {
        fontWeight: '600'
    },
    [`& .${classes.preTripHeading}`]: {
        fontSize: '2.4rem',
        fontWeight: '500',
        letterSpacing: '1.2px'
    },
    [`& .${classes.preTripText}`]: {
        fontSize: '1.2rem',
        marginTop: '10px',
        marginBottom: '20px',
    },
    [`& .${classes.PreTripBtn}`]: {
        color: '#fff',
        fontWeight: 500
    }
}));

const PaymentCard = ({booking: {booking: bookingData, payments}}) => {
    // const tripName = trip.shortcomment.includes('-') ? trip.shortcomment.split(' - ')[1] : trip.shortcomment;
    const {id} = useParams();
    const history = useHistory();

    const tripDate = endOfDay(parse(bookingData.tripDate, 'yyyy-MM-dd', new Date()));
    const isPreviousTrip = isPast(tripDate);


    const goToPayment = () => {
        history.push(`/booking/my-bookings/${id}/payment`);
    };

    /*const openTripBrochure = () => {
        window.open(trip.preTripInfo.pdfFile, '_blank');
    };*/

    return (
        <PaymentPaper className={classes.root} elevation={3} sx={{mx: {xs: '1.6rem', lg: '0'}}}>
            <Grid container>
                <PreTripCard booking={bookingData} myBooking viewDetails />
            </Grid>
            <Table>
                <TableHead>
                    <TableRow>
                        <StyledTableCell>
                            <Typography variant={"h5"}
                                        style={{fontWeight: 600, fontSize: '1.8rem'}}>Payments</Typography>
                        </StyledTableCell>
                        <StyledTableCell/>
                        <StyledTableCell/>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {payments.map((payment, index) => (
                        <StyledTableRow key={index}>
                            <StyledTableCell>
                                <p>
                                    {payment.title}&nbsp;
                                    {payment.paid ? (
                                        <span style={{whiteSpace: 'nowrap'}} className={`${classes.status} ${classes.paid}`}>paid</span>) : (
                                        <span style={{whiteSpace: 'nowrap'}} className={`${classes.status} ${classes.waiting}`}>awaiting</span>)}
                                </p>
                            </StyledTableCell>
                            <StyledTableCell>
                                <p style={{whiteSpace: 'nowrap'}}>
                                    {!payment.amount.includes('$') && '$ '}{payment.amount}
                                </p>
                            </StyledTableCell>
                            <StyledTableCell>
                                {!(payment.paid) && !isPreviousTrip &&
                                    <PrimaryButton style={{whiteSpace: 'nowrap', width: 'auto'}} onClick={goToPayment}>Pay Now</PrimaryButton>}
                            </StyledTableCell>
                        </StyledTableRow>
                    ))}
                </TableBody>
            </Table>
        </PaymentPaper>
    );
};

export default PaymentCard;

PaymentCard.propTypes = {
    booking: BookingPropTypes,
};